import React, { useEffect, useState } from 'react'

// Components
import { SearchableOverview } from '../../../_components/SearchableOverview/SearchableOverview'
import { AppendParams } from '../../../_helpers/util'
import { getAllInvoiceCount, getAllInvoicesForTenant } from '../../../_services/lender.service'
import { defaultColumns, InvoicesTable } from '../InvoicesTable'
import { openClientInvoiceColumns } from './tableColumns'

export const createInvoiceTable = (stateParam = null, columns) => {
  return {
    endpointCall: (searchParams) => {
      if (stateParam) {
        searchParams = AppendParams(searchParams, stateParam)
      }
      const alreadySorted = searchParams.has('sort_by')
      if (!alreadySorted) {
        searchParams.set('sort_by', 'updated_at')
        searchParams.set('sort_asc', false)
      }
      return Promise.all([
        getAllInvoicesForTenant(searchParams.toString()),
        getAllInvoiceCount(searchParams.toString()),
      ]).then((values) => {
        const invoicesList = values[0]
        invoicesList.forEach((invoice) => {
          if (invoice.business && invoice.business.business_name) {
            invoice.business_name = invoice.business.business_name
          }
        })
        return {
          results: invoicesList,
          total_results: values[1].num_invoices,
        }
      })
    },
    requestMethod: 'GET',
    pageSize: 25,
    columns: columns || defaultColumns,
    Component: ({ results, sort, handleSortChange, pageSize, columns }) => {
      return (
        <InvoicesTable
          columns={columns}
          handleSort={handleSortChange}
          invoices={results}
          pageSize={pageSize}
          sorted={sort}
        />
      )
    },
  }
}

export const ClientInvoiceTable = (props) => {
  let businessId = props.businessId
  let type = props.type
  let businessIdParam = `&business_id=${businessId}`

  if (!businessId) {
    return null
  }

  const [views, setViews] = useState([])
  const invoiceTypes = {
    pending: [
      createInvoiceTable(
        `${businessIdParam}&state=pending`,
        openClientInvoiceColumns.map((col) => {
          if (col.accessor === 'debtor_name') {
            col.headingText = 'Customer'
          }
          return col
        })
      ),
    ],
    open: [
      createInvoiceTable(
        `${businessIdParam}&state[]=purchased`,
        openClientInvoiceColumns.map((col) => {
          if (col.accessor === 'debtor_name') {
            col.headingText = 'Customer'
          }
          return col
        })
      ),
    ],
  }

  useEffect(() => {
    if (views.length == 0) {
      setViews(invoiceTypes[type])
    }
  })

  return <SearchableOverview showSearchBar={false} views={views} />
}
